export const QUERY_BUILDER_SEARCH_REQUEST = 'QUERY_BUILDER_SEARCH_REQUEST';
export const QUERY_BUILDER_SEARCH_SUCCESS = 'QUERY_BUILDER_SEARCH_SUCCESS';
export const QUERY_BUILDER_SEARCH_ERROR = 'QUERY_BUILDER_SEARCH_ERROR';

export const QUERY_BUILDER_DELETE_REQUEST = 'QUERY_BUILDER_DELETE_REQUEST';
export const QUERY_BUILDER_DELETE_SUCCESS = 'QUERY_BUILDER_DELETE_SUCCESS';
export const QUERY_BUILDER_DELETE_ERROR = 'QUERY_BUILDER_DELETE_ERROR';

export const QUERY_BUILDER_MODULE_LABELS_REQUEST = 'QUERY_BUILDER_MODULE_LABELS_REQUEST';
export const QUERY_BUILDER_MODULE_LABELS_SUCCESS = 'QUERY_BUILDER_MODULE_LABELS_SUCCESS';
export const QUERY_BUILDER_RECORD_TYPE_LABELS_REQUEST = 'QUERY_BUILDER_RECORD_TYPE_LABELS_REQUEST';
export const QUERY_BUILDER_RECORD_TYPE_LABELS_SUCCESS = 'QUERY_BUILDER_RECORD_TYPE_LABELS_SUCCESS';
export const QUERY_BUILDER_LABELS_ERROR = 'QUERY_BUILDER_LABELS_ERROR';

export const QUERY_BUILDER_RUN_REQUEST = 'QUERY_BUILDER_RUN_REQUEST';
export const QUERY_BUILDER_RUN_SUCCESS = 'QUERY_BUILDER_RUN_SUCCESS';
export const QUERY_BUILDER_RUN_ERROR = 'QUERY_BUILDER_RUN_ERROR';
export const QUERY_BUILDER_RESULTS_CLEAR = 'QUERY_BUILDER_RESULTS_CLEAR';

export const QUERY_EDITOR_CATALOG_REQUEST = 'QUERY_EDITOR_CATALOG_REQUEST';
export const QUERY_EDITOR_CATALOG_SUCCESS = 'QUERY_EDITOR_CATALOG_SUCCESS';
export const QUERY_EDITOR_CATALOG_ERROR = 'QUERY_EDITOR_CATALOG_ERROR';

export const QUERY_EDITOR_LOAD_REQUEST = 'QUERY_EDITOR_LOAD_REQUEST';
export const QUERY_EDITOR_LOAD_SUCCESS = 'QUERY_EDITOR_LOAD_SUCCESS';
export const QUERY_EDITOR_LOAD_ERROR = 'QUERY_EDITOR_LOAD_ERROR';

export const QUERY_EDITOR_SAVE_REQUEST = 'QUERY_EDITOR_SAVE_REQUEST';
export const QUERY_EDITOR_SAVE_SUCCESS = 'QUERY_EDITOR_SAVE_SUCCESS';
export const QUERY_EDITOR_SAVE_ERROR = 'QUERY_EDITOR_SAVE_ERROR';

export const QUERY_EDITOR_TEST_REQUEST = 'QUERY_EDITOR_TEST_REQUEST';
export const QUERY_EDITOR_TEST_SUCCESS = 'QUERY_EDITOR_TEST_SUCCESS';
export const QUERY_EDITOR_TEST_ERROR = 'QUERY_EDITOR_TEST_ERROR';
export const QUERY_EDITOR_TEST_INVALIDATE = 'QUERY_EDITOR_TEST_INVALIDATE';

export const QUERY_EDITOR_CLEAR = 'QUERY_EDITOR_CLEAR';
